exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-50fa0d8a]{padding:0;margin:0;margin-bottom:35px;border-bottom:0}h6.head-title[data-v-50fa0d8a]{margin-bottom:20px;font-size:1.1rem}.modal-body[data-v-50fa0d8a]{max-height:60vh;overflow-y:auto}.modal-footer[data-v-50fa0d8a]{padding:0;margin-top:18px;border:0}.form-group[data-v-50fa0d8a]{margin-bottom:3px}.list-unstyled[data-v-50fa0d8a]{max-height:40vh;overflow-y:auto;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50fa0d8a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/employee/modals/DeleteEmployeeDocumentForm.vue
// module id = Ab8w
// module chunks = 0